// Libs
import React, { Component } from "react";
import Cookies from "js-cookie";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// Components
import { ButtonSpocket } from "shared_components";
import SignUpFormContainer from "./signup/SignUpFormContainer";
import Divider from "../component/Divider";
import SocialButton from "../component/SocialButton";
import { default as Loadable } from "../../components/_Shared/commonLoadable";

// Images
import spocketLogo from "../images/spocket-logo.svg";

// Style
import "./Signup.css";

// Utils
import { formatUtm } from "../utils/utm";
import { gaEvent } from "../utils/trackEvents";

const SignupButtonTheme = {
  backgroundColor: "#f1ecfb",
  borderRadius: "21px",
  padding: "11px 31px",
  fontSize: "14px",
  color: "#8144e5",
  fontWeight: 600,
  boxShadow: "none"
};

class Signup extends Component {

  componentDidMount = () => {
    const spocketUtm = Cookies.get("spocket_utm");
    const formattedSpocketUtm = spocketUtm ? formatUtm(spocketUtm) : {};

    if (Object.keys(formattedSpocketUtm).length === 0) {
      Cookies.set("spocket_utm", window.location.search, {
        expires: 30,
        domain: ".spocket.co",
        path: "/"
      });
    }

    if (window.location.search.includes("email")) {
      localStorage.setItem("landing_page_signup", "variant");
    } else if (window.location.search.includes("id")) {
      localStorage.setItem("landing_page_signup", "control");
    } else if (
      window.location.search.length > 0 &&
      !["email, id"].includes(window.location.search)
    ) {
      localStorage.setItem("landing_page_signup", "notIncluded");
    }
  };

  // While loading - Check if user accessed the signup page with an email
  // EX: https://app.spocket.co/signup?email=john@spocket.co
  isDirectSignUpLoading = () => {
    if (
      window.location.search.includes("email") &&
      this.props.signUpError === false
    ) {
      gaEvent({
        category: "Sign Up Error",
        action: "Direct Sign Up"
      });
      return true;
    }
  };

  render() {
    return (
      <Loadable active={this.props.isFetching}>
        <div className="Signup__container">
          <div
            className="Signup__container-top"
            style={{
              display: this.isDirectSignUpLoading() ? "none" : "flex"
            }}
          >
            <header>
              <img src={spocketLogo} alt="Spocket Logo" />
              <ButtonSpocket
                onClick={() => {
                  browserHistory.push("/login");
                }}
                customButton={SignupButtonTheme}
              >
                Sign in
              </ButtonSpocket>
            </header>

            <div className="Signup__content">
              <main>
                <div className="Signup__titles">
                  <div>You’re 2 minutes away</div>
                  <div>from building your ecommerce empire</div>
                </div>
                <div className="Signup__form">
                  <SignUpFormContainer />
                </div>
                <Divider>or</Divider>

                <div className="Signup__social-buttons">
                  <SocialButton type="google">Sign up with Google</SocialButton>
                  <SocialButton type="facebook">
                    Sign up with Facebook
                  </SocialButton>
                </div>
              </main>
            </div>
          </div>
          <footer
            className={`Signup__footer ${this.isDirectSignUpLoading() ? "Signup__footer--direct-sign-up" : ""}`}
          >
            <q>
              Spocket enabled me to make $178,492 in three months by
              dropshipping US and European products
            </q>
            <p>- Marc Chapon, Entrepreneur</p>
          </footer>
        </div>
      </Loadable>
    );
  }
}

function mapStateToProps(state) {
  return {
    isFetching: state.signUp.isFetching,
    signUpError: "error" in state.signUp
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Signup);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/Signup.js